import { useState } from "react";
import { fetchVisitorByCode } from "../lib/apiClient"; 
import { useEvent } from "../contexts/EventContext";

export function useVisitorLookup() {
  const [visitor, setVisitor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { eventDate } = useEvent();

  const lookupVisitor = async ({ encodedSynergyId, eventDate, eventTableKey }) => {
    if (!encodedSynergyId || !eventDate || !eventTableKey) return;

    setLoading(true);
    setError(null);
    setVisitor(null);

    try {
      // APIで結果を受け取る
      const r = await fetchVisitorByCode({
        encodedSynergyId,
        eventDate,
        eventTableKey,
      });

      // 複数受け取る場合は以下で整形する
      // const r = res.data;
      const visitorData = {
        history_id: Array.isArray(r.history_id) ? r.history_id.at(-1) : r.history_id,
        visitor_name: r.visitor_name,
        visitor_name_kana: r.visitor_name_kana,
        company_name: r.company_name,
        department_name: r.department_name,
        position_name: r.position_name,
        industry: r.industry,
        preferred_visit_date: r.preferred_visit_date,
        visit_transportation: r.visit_transportation,
        visit_transportation_other_text: r.visit_transportation_other_text,
        applied_at: r.applied_at,
        event_name: r.event_name,
        applied_seminars: r.applied_seminars,
        visited: r.visited,
      }

      setVisitor(visitorData);
      setError(null);
      return visitorData;
    } catch (e) {
      setError(
        e?.response?.data?.message ??
        "来場者情報の取得に失敗しました"
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    lookupVisitor,
    visitor,
    loading,
    error,
  };
}
